import { SET_LANGUAGE } from './actionTypes'

// 기본값은 env 로케일(REACT_APP_LOCALE: xxx/hub=ko, jp=ja) → 없으면 'ja'. i18n.js와 동일 규칙.
// (하드코딩 'ja'면 env가 ko여도 redux state가 ja로 저장되고, 다음 로드때 i18n이 그 ja를 읽어 env를 덮어썼음)
let initialLang = process.env.REACT_APP_LOCALE || 'ja'
try {
  const parsed = JSON.parse(localStorage.getItem('info'))
  if (parsed?.Language?.language) {
    initialLang = parsed.Language.language
  }
} catch (e) {}

const initialState = {
  language: initialLang,
}

const Language = (state = initialState, action) => {
  switch (action.type) {
    case SET_LANGUAGE:
      return { ...state, language: action.language }
    default:
      return state
  }
}

export default Language
